'use client'
import {
  context_default as context_default2
} from "./chunk-DG2ER5TA.mjs";
import {
  context_default
} from "./chunk-V3JSSRKS.mjs";
import {
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/context/root/useConfig.ts
import { useContext } from "react";
var useCalendarConfig = () => {
  const context = useContext(context_default2);
  const config = useContext(context_default);
  if (!context && !config) {
    throw new Error("useCalendarConfig must be used within a CalendarProvider");
  }
  return __spreadValues(__spreadValues({}, config), context);
};
var useConfig_default = useCalendarConfig;

export {
  useCalendarConfig,
  useConfig_default
};
//# sourceMappingURL=chunk-V5VPZNVL.mjs.map